// extracted by mini-css-extract-plugin
export default {"noMatchFoundText":"DashboardUpcomingAppointmentList_noMatchFoundText__5Y-uC"};